import { render, staticRenderFns } from "./rf_flex.vue?vue&type=template&id=f5c5365c&scoped=true&"
import script from "./rf_flex.vue?vue&type=script&lang=js&"
export * from "./rf_flex.vue?vue&type=script&lang=js&"
import style0 from "./rf_flex.vue?vue&type=style&index=0&id=f5c5365c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c5365c",
  null
  
)

export default component.exports